import { useEffect, useState } from "react";

export interface DateInputDDMMYYYYProps {
  value?: string | null;
  onChange: (isoDate: string) => void;
  className?: string;
}

function isoToDisplay(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-");
  if (!y || !m || !d) return "";
  return `${d}.${m}.${y}`;
}

function displayToIso(display: string): string | null {
  const match = display.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!match) return null;
  const day = (match[1] ?? "").padStart(2, "0");
  const month = (match[2] ?? "").padStart(2, "0");
  const year = match[3] ?? "";
  if (!year || Number(day) < 1 || Number(day) > 31 || Number(month) < 1 || Number(month) > 12) return null;
  return `${year}-${month}-${day}`;
}

/**
 * Prikazuje/prima datum ISKLJUČIVO u dd-mm-gggg formatu, bez obzira na
 * lokal/jezik browsera korisnika (native `<input type="date">` prikazuje
 * format zavisno od lokala browsera, što je zbunjivalo korisnike koji
 * očekuju srpski zapis datuma).
 */
export function DateInputDDMMYYYY({ value, onChange, className }: DateInputDDMMYYYYProps) {
  const [text, setText] = useState(value ? isoToDisplay(value) : "");

  useEffect(() => {
    setText(value ? isoToDisplay(value) : "");
  }, [value]);

  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder="dd.mm.gggg"
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={() => {
        const iso = displayToIso(text);
        if (iso) {
          onChange(iso);
        } else if (text.trim() === "") {
          // Prazno polje se namerno ne prosleđuje kao promena.
        } else {
          setText(value ? isoToDisplay(value) : "");
        }
      }}
      className={
        className ??
        "h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
      }
    />
  );
}
